import r2wc from '@r2wc/react-to-web-component';
import '@webcomponents/custom-elements';
import CheckoutWidget from '../widgets/CheckoutWidget';

const WebCheckoutWidget = r2wc(CheckoutWidget, {
  props: {
    thgConfig: 'json',
    configOverrides: 'json',
    rerouteUrl: 'string',
    homepageUrl: 'string',
    mode: 'string',
    triggerSearch: 'boolean',
    widgetSessionKeyPrefix: 'string',
    origin: 'json',
    origins: 'json',
    destination: 'json',
    destinations: 'json',
    startDate: 'string',
    endDate: 'string',
    occupancy: 'json',
    directFlightsOnly: 'boolean',
    packageServiceGroup: 'string',
    subType: 'json',
    dateInputType: 'json',
    duration: 'number',
    packageCode: 'string',
    salesChannel: 'string',
    mainServiceCodes: 'json',
    preSelectedCharacteristics: 'json',
    inventories: 'json',
    productId: 'string',
    destinationItem: 'json',
    goToDetails: 'boolean',
    isFromSearchButton: 'boolean',
    listOptions: 'json',
    postalCode: 'string'
  }
});

customElements.get('thg-checkout') || customElements.define('thg-checkout', WebCheckoutWidget);
